import { createFileRoute } from "@tanstack/react-router";
import Billing from "@/pages/Billing";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dashboard/billing/")({
  head: () => routeHead("/de/dashboard/billing/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><Billing /></PrivateRoute>
  );
}
